var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80 805v-60q38 0 61.5-23t68.5-23 70 27 64 27 65-27 71-27 70.5 27 64.5 27 64.5-27 70.5-27 68.5 23 61.5 23v60q-47 0-69.5-23T750 759t-64 27-71 27-71-27-64-27-64.5 27-71.5 27-70.5-27-63.5-27-60.5 23T80 805m0-160v-60q38 0 61.5-23t68.5-23 70 27 64 27 65-27 71-27 70.5 27 64.5 27 64.5-27 70.5-27 68.5 23 61.5 23v60q-47 0-69.5-23T750 599t-64 27-71 27-71-27-64-27-64.5 27-71.5 27-70.5-27-63.5-27-60.5 23T80 645m0-160v-60q38 0 61.5-23t68.5-23 70 27 64 27 65-27 71-27 70.5 27 64.5 27 64.5-27 70.5-27 68.5 23 61.5 23v60q-47 0-69.5-23T750 439t-64 27-71 27-71-27-64-27-64.5 27-71.5 27-70.5-27-63.5-27-60.5 23T80 485"
  })));
};
export default SvgWater;